function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n      box-shadow: ", ";\n    "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import { InlineChildren, Shadows } from '@doordash/design-language';
import styled, { css } from 'styled-components';
export var ActionsContainer = styled(InlineChildren).attrs({
  size: InlineChildren.Sizes.XxSmall,
  alignItems: InlineChildren.Alignment.Center
})(_templateObject());
export var NavBarContainer = styled.nav(_templateObject2(), function (props) {
  return props.isRaised && css(_templateObject3(), Shadows.Base);
});